
// a cell of the grid DataSheet draws - made from the server's SOV lines (linesDecoder)
export interface Cell {
    value: string,
    // The convention for party: 0(false)=Developer, 1(true)=bidder
    party: boolean,
    type?: string | null,
    feedback?: any
    // the SOV cell id
    id?: number,
}

// row level data - lined up with the rows of a Cell[][]
export interface RowMeta {
    // a line only developers see. the server never sends these rows to bidders
    developer_only?: boolean;
}

// the SOV (server bid_sov_schema) - the config's lines, with one bid's values when it is a bid's
export interface SovCell {
    id: number;
    kind: "label" | "input";
    type?: string | null;
    text: string;
    value?: any;
    feedback?: any;
}

export interface SovLine {
    developer_only: boolean;
    cells: SovCell[];
}

// the SOV itself (server SovConfig) - lines of cells with ids, no values (those are on the bids).
// edited one change at a time - server bid_sov_routes. each edit returns the whole config
export interface SovConfig {
    id: string;
    project_id: string;
    scope_id: string | null;
    name: string;
    version: number;
    cell_seq: number;
    is_active: boolean;
    lines: SovLine[];
}

// what a bid stores of its SOV (server BidderSOV) - the bidder's values by cell id on config_id.
// save / submit / copy send it back
export interface BidderSov {
    config_id: string;
    values: Record<string, {value: any}>;
}

/** the bidder's values in the grid by cell id - every input that came from sov_lines */
export function sheetValues(sheet: Cell[][]): Record<string, {value: any}> {
    const out: Record<string, {value: any}> = {};
    sheet.forEach((row) => row.forEach((cell) => {
        if (cell.party && cell.id != null) {
            out[String(cell.id)] = {value: cell.value};
        }
    }));
    return out;
}

/**
 * SOV lines -> the grid DataSheet draws. labels show their text, inputs the bid's value.
 * values come as strings, like the ones typed into the grid
 */
export function linesDecoder(lines: SovLine[]): Cell[][] {
    return lines.map((line) => line.cells.map((cell) => cell.kind === "input"
        ? {id: cell.id, value: cell.value == null ? "" : String(cell.value), party: true, type: cell.type,
           feedback: cell.feedback}
        : {id: cell.id, value: cell.text, party: false}));
}

/** the row level data of SOV lines - see RowMeta */
export function linesRowMeta(lines: SovLine[]): RowMeta[] {
    return lines.map((line) => ({developer_only: line.developer_only}));
}
